import type { WorldSlug } from '@/lib/worlds';

/**
 * Resolve the cover-art URL for a story based on its world.
 *
 * Per-slug lookup against the hero card SVGs in `pwa/public/covers/`.
 * Consumed by:
 *   - `StoryCard density="start"` (Start-Page "Letzte Geschichten" cards
 *     — 75×60 cover tile) via `pwa/src/components/patterns/StoryCard.tsx`
 *   - `MiniPlayer` cover (44×44) via `pwa/src/components/shell/MiniPlayer.tsx`
 *
 * Library-density (40×40) uses `getLibraryCover()` from `@/lib/worldAssets`
 * which renders a different per-world asset variant (`Library_*.svg`).
 *
 * Fallback (`cover-default.svg`) only fires on null/unknown slug — typically
 * the LibraryRoute startup race window before `worldSlugMap` resolves, per
 * the `worldAssets.ts:13-16` comment.
 */

const FALLBACK_COVER = '/covers/cover-default.svg';

const START_COVER_BY_SLUG: Record<WorldSlug, string> = {
  aa: '/covers/card-world-img_AA.svg',
  kp: '/covers/card-world-img_KP.svg',
  sb: '/covers/card-world-img_SB.svg',
};

export function getCoverForWorld(slug: WorldSlug | null | undefined): string {
  if (!slug) return FALLBACK_COVER;
  return START_COVER_BY_SLUG[slug] ?? FALLBACK_COVER;
}
